import * as Diagram from "../../../../components/diagram";

export const ClosedCaseList = {
  label: "結案名冊(結案名冊清單)",
  key: "ClosedCaseList",
  path: "VolunteerCare/ClosedCaseList",
  api: "TCS_V_VolunteerCare_6",
  render: (options) => <Diagram.VolunteerCare.ClosedCaseList {...options} />,
  isRaw: true,
  isPage: true,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  columns: [
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證字號",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "連絡電話",
      field: "連絡電話",
      header: "連絡電話",
    },
    {
      key: "行動電話",
      field: "行動電話",
      header: "行動電話",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "個案來源",
      field: "個案來源",
      header: "個案來源",
    },
    {
      key: "開案日期",
      field: "開案日期",
      header: "開案日期",
    },
    {
      key: "訪視日期",
      field: "訪視日期",
      header: "結案日期",
    },
    {
      key: "L1-BSRS-5",
      field: "L1-BSRS-5",
      header: "L1-BSRS-5",
    },
    {
      key: "L1-自殺",
      field: "L1-自殺",
      header: "L1-自殺",
    },
    {
      key: "L1-GDS-15",
      field: "L1-GDS-15",
      header: "L1-GDS-15",
    },
    {
      key: "L2-BSRS-5",
      field: "L2-BSRS-5",
      header: "L2-BSRS-5",
    },
    {
      key: "L2-自殺",
      field: "L2-自殺",
      header: "L2-自殺",
    },
    {
      key: "L2-GDS-15",
      field: "L2-GDS-15",
      header: "L2-GDS-15",
    },
    {
      key: "L3-BSRS-5",
      field: "L3-BSRS-5",
      header: "L3-BSRS-5",
    },
    {
      key: "L3-自殺",
      field: "L3-自殺",
      header: "L3-自殺",
    },
    {
      key: "L3-GDS-15",
      field: "L3-GDS-15",
      header: "L3-GDS-15",
    },
  ],
};
